import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const itemSchema: CollectionCreateSchema = {
  name: CollectionName.Item,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "list_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "un_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "parent_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "effective_start_date",
      type: "int64",
      sort: true,
    },
    {
      name: "active",
      type: "bool",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "effective_end_date",
      type: "int64",
      optional: true,
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
